<template lang="pug">
    .entry-wrapper(v-if="entry")
      div
          h1 {{entry.title}}
          hr
      div
          .page(v-html="entry.body")
</template>

<script>
import _ from 'underscore'
import Api from './services/Api'

export default {
  name: 'Entry',
  props: ['slug'],
  data() {
    return {
      entry: null,
      // slug: null,
    }
  },
  created() {
    this.loadContent()
  },
  methods: {
    loadContent() {
      const _this = this
      let slug = this.slug

      this.$wagtail
        .getEntry(slug, 0)
        .then(response => {
          _this.entry = _.first(response.data.results)
          document.body.scrollTop = document.documentElement.scrollTop = 0
        })
        .catch()
    },
  },
}
</script>

<style scoped lang="scss">
@import './../variables';
.entry-wrapper {
  padding-bottom: $gutter;
  // margin-bottom: $gutter*4;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  max-width: 1140px;
  margin: 0 auto $gutter * 4 auto;

  @include breakpoint($breakpoint-mobile) {
    margin: 0;
  }

  & > div {
    width: 85%;
    display: block;
    margin: 0 auto;
  }

  h1 {
    font-weight: 700;
    font-size: 2.2rem;
    margin: $gutter * 4 0 50px 0;
  }

  hr {
    margin: 0;
    border: 2px solid $color-primary;
    margin-bottom: $gutter * 3;
    display: block;
    clear: both;
    width: 55px;
  }

  @include breakpoint($breakpoint-tablet) {
    hr {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Entry.vue